import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c431cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v-navigation-app__top lo-g-row" }
const _hoisted_2 = { class: "v-navigation-app__top__date" }
const _hoisted_3 = { class: "v-navigation-app__top__date-mobile" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "v-navigation-app__top__logo",
  src: "/img/NC_logo.svg",
  alt: "logo"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 213.8 213.8",
  style: {"enable-background":"new 0 0 213.8 213.8"},
  "xml:space": "preserve"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", { points: "213.8,23.8 190.1,0 106.9,83.2 23.8,0 0,23.8 83.2,106.9 0,190.1 23.8,213.8 106.9,130.7 190.1,213.8 213.8,190.1 130.7,106.9 " }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 268.8 212.8",
  style: {"enable-background":"new 0 0 268.8 212.8"},
  "xml:space": "preserve"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0,0v33.6h268.8V0H0z M0,89.6v33.6h268.8V89.6H0z M0,179.2v33.6h268.8v-33.6H0z" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "v-navigation-app__bottom lo-g-box lo-g-box--centred lo-g-row" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Level One")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Spécifications")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Biographie")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Talents")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Pré-commande")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Certificats")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["v-navigation-app", {'hide': _ctx.hide}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.date), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dateMobile), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          class: "v-navigation-app__top__logo-link",
          to: {path: '/', hash: '#v-home__main'}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
          class: "v-navigation-app__top__toggle-menu"
        }, [
          _createElementVNode("div", null, [
            (_ctx.store.state.menuOpen)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
              : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: {path: '/', hash: '#v-home__main'}
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: {path: '/', hash: '#v-home__specification'}
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: {path: '/', hash: '#v-home__bio'}
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: {path: '/', hash: '#v-home__talents'}
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: "/pre-order"
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "lo-g-gutter--half",
        to: "/certification"
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ], 2))
}